/* eslint no-underscore-dangle: 0 */

//  This functions checks if given input name is empty or not
function checkIfEmpty(name){
    
    let check = false;
    if(name === ''){
        check = true;
    }
    return check;
}


/**
 * This functions takes as parameters  a new block name and grapesJs editor
 * It checks if new name already exists in editor's premade blocks, or 
 * in created data elements blocks or in created services blocks.
 */
function checkDublicateBlockName(name, editor){
    let check = false;

    if(editor.BlockManager !== undefined){
        editor.BlockManager.getAll().forEach( block => {

            //  Check if new name exists in editor's premade blocks no matter if first letter is upper or lower
            const upperName = block.attributes.id.charAt(0).toUpperCase() + block.attributes.id.slice(1);

            if( block.attributes.id === name || upperName ===  name){
                check = true;
            }
        })
    }

    const tempData = JSON.parse(localStorage.getItem('data'));

    tempData.forEach( (project) => {
        //  Check if given name already exists as a service block name
        if( project.services !== undefined && project.services[0] !== undefined && project.services[0].services_blocks !== undefined){
            project.services[0].services_blocks.forEach( (servicePerProject) => {
                if(servicePerProject.label === name){
                    check =true;
                }
    
            })
        }
       
        //  Check if given name already exists as a data element block name
        if( project.data_elements !== undefined){
            project.data_elements.data_elements_blocks.forEach( (dataElementBlock) => {
                if(dataElementBlock.label === name){
                    check = true;
                }
            })
        }
    })

    return check;
}

//  This functions returns if a name has spaces or not.
function checkHasSpaces(name){
    let exists = false;
    if(/\s/.test(name)){
        exists = true;
    }
    return exists;
}

/**
 * This functions returns if a given block name exists in list of data element block names 
 * of a selected project , except the data element block that layes on a given index of data element
 * blocks inside selected project. 
*/
function checkExistDataElementName(name,selectedProject,indexEditBlockDataElement){
    let exists= false;
    const tempData = JSON.parse(localStorage.getItem('data'));
    if(tempData !== undefined && tempData !== null && selectedProject > -1 && tempData[selectedProject] !==undefined){
        tempData[selectedProject].data_elements.data_elements_blocks.forEach( (dataElementBlock, index) =>{
            if(dataElementBlock.blocks[0].id === name && index !== indexEditBlockDataElement){
                exists = true;
            }
        })
        return exists;
    }
    return exists;
}

//  This function returns if given page name exists in page names of a selected project
function checkPageNameExists(name,selectedProject,selectedPage){
    let exists = false;

    if (selectedPage > -1 && selectedProject > -1) {
     
      if( JSON.parse(localStorage.getItem("data")) !== null ){

        const projects = JSON.parse(localStorage.getItem("data"))[selectedProject];

        projects.pages.forEach((value, index) => {
            if (index !== selectedPage && name === value.name) {
                exists = true;
            }
        });
      }
    }
    return exists;
}

//  This function returns if a given name exists in table of names
function checkIfNameExists(name, table){

    let exists = false;

    table.forEach((val) => {
        if(val === name || name.toString() === val){
            exists = true;
        }
    })
    return exists;
}

/**
 * This function returns, if arg exists inside the table, the  index of the given arg inside table,
 * if it does not exists then returns -1. 
*/
function findIndexIfArgExists(arg, table){
    let index = -1;

    table.forEach( (val, tableIndex) => {
        if(val.toString() === arg.toString() ){
            index = tableIndex            
        }
    })

    return index;
}

/**
 * This function takes a parameter isEdit which defines if we edit project's info or if we create a new project,
 * currentId which is used when isEdit is true and represents the id of the curren project and appName which defines
 * the given app name.If is in edit mode then it checks for others project's names to check if given name already 
 * exists.If it is not in edit mode, but we create a new one, then we check for all stored names in projects info
 * to see if given name already exists.
 */
function checkIfAppNameExists(isEdit,currentId,appName){
    let exists = false;
    const tempLocalStorage = JSON.parse(localStorage.getItem('data'));

    //  Edit mode
    if(isEdit === true){

        if(tempLocalStorage !== null){
            tempLocalStorage.forEach((val) => {
                if (appName === val.name && currentId !== val._id) {
                    exists = true;
                }
            });
        }   
    }
    //  Create new project mode
    else{
        tempLocalStorage.forEach((val) => {
            if (appName === val.name) {
                exists = true;
            }
        });
    }

    return exists;
}

/**
 * This functions takes as parameters annotationName and a selectedProject and checks if 
 * given annotationName already exists in stored annotation combinations of selected 
 * project.If exists then returns the index of stored annotation combination else it 
 * returns -1.
 */
function findCombinationIndex (annotationName,selectedProject) {

    let indexCombination = -1;
  
    const tempData = JSON.parse(localStorage.getItem('data'));

    if(tempData === null || tempData === undefined){
        return indexCombination;
    }

    if(tempData[selectedProject] === undefined){
        return indexCombination
    }
  
    if(tempData[selectedProject].annotations[0] !== undefined && tempData[selectedProject].annotations[0].combinations !== undefined){
  
      const tempDataCombinations = tempData[selectedProject].annotations[0].combinations;
      tempDataCombinations.forEach( (combination,index) => {
        if(combination.annotationName === annotationName){
          indexCombination = index;
        }
      })
    }
    return indexCombination;
  
}

function checkIfAppNameHasSpaces(name){

    return name.includes(' ');
}

const nameExists = (selectedPage,selectedProject) => {
    let exists = false;

    const tempLocalStorage = JSON.parse(localStorage.getItem('data'));

    if(selectedPage > -1 && selectedProject > -1){

        const currentName = tempLocalStorage[selectedProject].pages[selectedPage].name;
        const projectPageNames = JSON.parse(localStorage.getItem('data'))[selectedProject];
        
        if (projectPageNames !== undefined) {
            projectPageNames.pages.forEach((value, index) => {
              if (index !== selectedPage) {
                if (currentName === value.name) {
                  exists = true;
                }
              }
            });
        }
    }
    return exists;
};

const nameNull = (selectedPage, selectedProject) => {
    let empty = false;

    const tempLocalStorage = JSON.parse(localStorage.getItem('data'));

    if (selectedPage > -1 && selectedProject > -1) {
        const currentName = tempLocalStorage[selectedProject].pages[selectedPage].name;

        if (currentName === '') {
            empty = true;
        }
    }

    return empty;
};

export {
    checkIfEmpty,
    checkDublicateBlockName,
    checkHasSpaces,
    checkExistDataElementName,
    checkPageNameExists,
    checkIfNameExists,
    checkIfAppNameExists,
    findCombinationIndex,
    findIndexIfArgExists,
    checkIfAppNameHasSpaces,
    nameExists,
    nameNull
};